<div *ngIf="item" class="keyDetails">
  <button (click)="onBack()" class="backbtn"><i class="fa fa-arrow-left" aria-hidden="true"></i></button>
  <ul>
    <li>
      <h3>{{ item.key }}: {{ item.summary }}</h3>
    </li>
    <li>{{ item.externalDesc }}</li>
    <li>
      <strong>Error Message:</strong>
      <div>
        {{ displayErrorMsg(item.errorMsg) }}
      </div>
    </li>
    <li><strong>Status:</strong>
      <ng-container *ngIf="item.status !== 'null'">{{ item.status }}</ng-container>
    </li>
    <li><strong>Workaround:</strong> {{ item.workaroundDesc }}</li>
  </ul>
</div>